module.exports = __webpack_public_path__ + "976b0a52e0c4c46dd906c983bf4f5404.mp4";